import secureAxios from '../secure_axios';

const baseUrl = 'indicador'

async function servPostIndicadorLote(formData) {
    const { data } = await secureAxios.post(
        `${baseUrl}/lote`,
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }
    );
    return data
}

async function servGetIndicador(query) {
    const { data } = await secureAxios.get(
        `${baseUrl}`,
        { params: query }
    )
    return data
}

async function servGetIndicadorComHistorico(query) {
    const { data } = await secureAxios.get(
        `${baseUrl}/historico-versoes`,
        { params: query }
    )
    return data
}

async function servGetIndicadorComAjustes(query) {
    const { data } = await secureAxios.get(
        `${baseUrl}/ajuste-excepcional`,
        { params: query }
    )
    return data
}

async function servPatchIndicador(query) {
    const { data } = await secureAxios.patch(
        baseUrl,
        query
    )
    return data
}

async function servPostIndicadorAjusteExcepcional(request) {
    const { data } = await secureAxios.post(
        `${baseUrl}/ajuste-excepcional`,
        request
    )
    return data
}

export {
    servPostIndicadorLote,
    servGetIndicador,
    servGetIndicadorComHistorico,
    servGetIndicadorComAjustes,
    servPatchIndicador,
    servPostIndicadorAjusteExcepcional
}
